<template>
    <section class="module bg-dark-20 pt-0 pb-0 parallaxImg overlay">
      <div class="just-a-wrapper">
        <video 
        muted
        playsInline
        loop
     ref="videoRef"
        controls 
        width="100%">
        <source src="/static/assets/images/Clips/720.mp4" type="video/mp4" />
        <img v-lazy="imgUrl1" title="Your browser does not support the <video> tag">
        Sorry, your browser doesn't support embedded videos.
      </video>
         <!-- <video ref="videoRef" src="/static/assets/images/Clips/720.webm" id="video-interstitial" loop muted width="100%" playsinline controls></video> -->
      <h1 class="slogan">TOWER DEFENSE <br> DUNGEON CRAWLER RPG</h1>
      </div>
     
    </section>
</template>

<script>

export default {
  data: function() {
    return {
      imgUrl1: '/static/assets/images/feat-fallback.png'
    };
  },
  methods: {
   
  },
  mounted() {
   // this.$refs.videoRef.src = "/static/assets/images/Clips/720.mp4";
    this.$refs.videoRef.play();
   // document.getElementById("video-interstitial").controls = false;
  }
};

</script>

<style>
@media all and (orientation:landscape) and (max-width: 900px) {
  .just-a-wrapper h1.slogan {
    font-size: 44px !important;
  }
}
.parallaxImg {

  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
  height: 500px;
  overflow: hidden;
  z-index: 0;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 0;
}
@media screen and (max-width: 850px) and (min-width: 550px){
  .slogan {
    line-height: 1.3 !important;
    font-size: 66px !important;
    top: 100px !important;
  }
  
}
@media only screen and (max-width: 550px){
  .slogan {
    line-height: 1.3 !important;
    font-size: 30px !important;
    top: 20px !important;
    padding: 20px;
  }
  .parallaxImg {
    height: 230px;
  }
}
.slogan {
  font-family: Grandmaster;
  line-height: 1.4;
  z-index: 1;
  top: 165px;
      width: 100%;
    position: absolute;
  font-size: 60px;
  color: #ffffff;
  text-align: center;
  text-shadow: -2.4px -2.4px 0 #1d1a44, -2.4px -1.4px 0 #1d1a44,
    -2.4px -0.4px 0 #1d1a44, -2.4px 0.6px 0 #1d1a44, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #1d1a44, -1.4px -2.4px 0 #1d1a44, -1.4px -1.4px 0 #1d1a44,
    -1.4px -0.4px 0 #1d1a44, -1.4px 0.6px 0 #1d1a44, -1.4px 1.6px 0 #1d1a44,
    -1.4px 2.6px 0 #1d1a44, -0.4px -2.4px 0 #1d1a44, -0.4px -1.4px 0 #1d1a44,
    -0.4px -0.4px 0 #1d1a44, -0.4px 0.6px 0 #1d1a44, -0.4px 1.6px 0 #1d1a44,
    -0.4px 2.6px 0 #1d1a44, 0.6px -2.4px 0 #1d1a44, 0.6px -1.4px 0 #1d1a44,
    0.6px -0.4px 0 #1d1a44, 0.6px 0.6px 0 #1d1a44, 0.6px 1.6px 0 #1d1a44,
    0.6px 2.6px 0 #1d1a44, 1.6px -2.4px 0 #1d1a44, 1.6px -1.4px 0 #1d1a44,
    1.6px -0.4px 0 #1d1a44, 1.6px 0.6px 0 #1d1a44, 1.6px 1.6px 0 #1d1a44,
    1.6px 2.6px 0 #1d1a44, 2.6px -2.4px 0 #1d1a44, 2.6px -1.4px 0 #1d1a44,
    2.6px -0.4px 0 #1d1a44, 2.6px 0.6px 0 #1d1a44, 2.6px 1.6px 0 #1d1a44;
}
.overlay:before {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
      z-index: 1;
    background-color: #0000009c;
}
.just-a-wrapper {
    max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Story.vue